/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";


import { Button} from "react-bootstrap";

import { NavLink } from "react-router-dom";

type QuizNextButtonProps = {
    TO: any;
    TITLE: string
    DISABLED: boolean;
};


export const QuizNextButtonComponent: React.FC<QuizNextButtonProps> = ({
    TO, TITLE, DISABLED
}): JSX.Element | null => {



    return (
        <>
            {DISABLED ?

                <Button disabled={DISABLED} size={"sm"} style={{ marginLeft: 5 }}>
                    <span>{TITLE}</span>
                </Button>

                :
                
                <NavLink to={TO} title={TITLE} >
                    <Button disabled={DISABLED} size={"sm"} style={{ marginLeft: 5 }}>
                        <span>{TITLE}</span>
                    </Button>
                </NavLink>
            }
        </>
    )
};


export default QuizNextButtonComponent;
